<template>
  <div class="hc__rounded-card">
      <form @submit.prevent="handleSubmitForm" multipart="true">
        <v-layout row wrap style="gap: 10px">
          <v-flex xs12 md6>
            <v-text-field
              v-model="current_user.full_name"
              label="Nombre Completo"
              required
              disabled
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md5>
            <v-text-field
              v-model="current_user.legal_number"
              label="R.U.T."
              required
              disabled
            ></v-text-field>
          </v-flex>

          <v-flex xs12 md6>
            <v-text-field
              v-model="current_user.email"
              label="Correo electrónico"
              required
              disabled
            ></v-text-field>
          </v-flex>

          <v-flex xs12 md5>
            <v-text-field
              v-model="current_user.company"
              label="Empresa"
              required
              disabled
            ></v-text-field>
          </v-flex>

          <v-flex xs12 md6>
            <v-text-field
              type="text"
              v-model="formattedAmount" 
              label="Ingresa el monto que quieres solicitar*"
              required
              :rules="[amountValidation]"
              prepend-inner-icon="attach_money"
              @keypress="onKeyPress"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 md5>
            <span> Selecciona la modalidad de tu anticipo*</span>
            <v-radio-group
              v-model="advance_payment.type"
              row
              :style="{ justifyContent: 'center' }"
              required
            >
              <v-radio label="Permanente" value="permanent"></v-radio>
              <v-radio label="Única Vez" value="once"></v-radio>
            </v-radio-group>
            <span v-if="advance_payment.type == 'once'" style="font-size: 12px">* El pago será en el
            periodo de {{ current_period }} </span>
            <span v-else style="font-size: 12px">* El primer pago se realizara en el
            periodo de {{ current_period }} </span>
          </v-flex>
        </v-layout>
      </form>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  data: () => ({
  }),
  props: {
    advance_payment: { type: Object, required: true },
    current_period: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState("user", ["current_user"]),
    formattedAmount: {
    get() {
      const amount = this.advance_payment.amount || '';
      return amount.toString().replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ".");
    },
    set(value) {
      this.advance_payment.amount = value.replace(/\D/g, "");
    },
  },
  },
  methods: {
    setFormData() {
      const formData = new FormData();
      formData.append("advance_payment[id]", this.advance_payment.id);
      formData.append("advance_payment[amount]", this.advance_payment.amount);
      formData.append(
        "advance_payment[advance_payment_type]",
        this.advance_payment.type
      );
      return formData;
    },
    handleSubmitForm() {
      const formData = this.setFormData();
      this.$emit("submitForm", formData);
    },
    amountValidation() {
      const amount = this.advance_payment.amount
      if (amount === null || amount === "") {
        return "Este campo es obligatorio";
      }

      if (amount < 10000) {
        return "El valor debe ser igual o superior a $10,000";
      }

      return true;
    },
    getMonthName(month) {
      const options = { month: 'long' };
      return new Date(2000, month - 1, 1).toLocaleString('es-ES', options);
    },
    onKeyPress(event) {
      const charCode = event.which || event.keyCode;
      const blockedCharacters = [39, 96];

      if ((charCode >= 48 && charCode <= 57) || blockedCharacters.includes(charCode)) {
      } else {
        event.preventDefault();
      }
    },
  },
  mounted() {
  }
};
</script>
<style lang="css">
.hc__rounded-card {
  border-radius: 0.5rem;
}
.v-input__prepend-outer {
  display: none;
}
</style>
